import { Logger } from '../../utils/logger';

import React, { useState } from 'react'

export default function Test() {
    const [file,setFile] = useState()
    const handleFile = (e)=>{
        Logger.log('handleFile ======>',e.target.files[0].name.split('.'))
    }
  return (
    <div>
        <h1>Test page </h1>
        <input type='file' onChange={(e)=>{handleFile(e)}}/>
    </div>
  )
}
